/**
 * NoReliefAlertSection ("No Relief alert") — Settings control for how the No Relief reminder gets this
 * user's attention in this session: popup + badge (default), badge only, or off.
 *
 * Personal to this user, remembered on this device, one setting per session ID (utils/noReliefAlert.ts) —
 * Settings groups it as "Only you · this session" (components/SettingsScopeSections).
 */
import { useSession } from "@/contexts/SessionContext";
import { NO_RELIEF_ALERT_OPTIONS, setNoReliefAlert, useNoReliefAlert } from "@/utils/noReliefAlert";

export function NoReliefAlertSection() {
  const { sessionId } = useSession();
  const value = useNoReliefAlert(sessionId);
  if (!sessionId) return null;
  return (
    <div style={{ fontSize: 14 }}>
      <div role="radiogroup" aria-label="No Relief alert" style={{ display: "flex", flexDirection: "column", gap: 6 }}>
        {NO_RELIEF_ALERT_OPTIONS.map((o) => (
          <label key={o.value} style={{ display: "flex", alignItems: "flex-start", gap: 8, cursor: "pointer" }}>
            <input
              type="radio"
              name="no-relief-alert"
              checked={value === o.value}
              onChange={() => setNoReliefAlert(sessionId, o.value)}
              style={{ width: 16, height: 16, marginTop: 2, cursor: "pointer" }}
            />
            <span>
              {o.label}
              <span style={{ display: "block", fontSize: 13, color: "#64748b", marginTop: 2 }}>{o.hint}</span>
            </span>
          </label>
        ))}
      </div>
    </div>
  );
}
